import * as actions from '../actions/editingSettings';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';

export function requestEditingSettingsEditableByOptions(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.FETCH_EDITING_SETTING_EDITABLE_BY_OPTIONS)
        .map(action => ({
            url: BASE_URL + 'api/Applications/AnswerApprovalOptions',
            category: 'requestEditingSettingsEditableByOptions',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestEditingSettingsEditableByOptions')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.fetchEditingSettingsEditableByOptionsSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestEditingSettingsEditableByOptionsFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestEditingSettingsEditableByOptions')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.fetchEditingSettingsEditableByOptionsFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestEditingSettings(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.FETCH_EDITING_SETTINGS)
        .map(action => ({
            url: BASE_URL + 'api/Applications/AnswerApprovalSettings',
            category: 'requestEditingSettings',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestEditingSettings')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.fetchEditingSettingsSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestEditingSettingsFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestEditingSettings')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.fetchEditingSettingsFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestUpdateEditingSettings(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.UPDATE_EDITING_SETTINGS)
        .map(action => ({
            url: BASE_URL + 'api/Applications/AnswerApprovalSettings',
            category: 'requestUpdateEditingSettings',
            method: 'PATCH',
            send: action.payload.sendBody,
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestUpdateEditingSettings')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.updateEditingSettingsSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestUpdateEditingSettingsFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestUpdateEditingSettings')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.updateEditingSettingsFailed(response));

    return {
        ACTION: httpResponse$
    };
}
